"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const types_1 = require("@osmosys/types");
const index_1 = require("../../../index");
let ContentConversionStepInput = class ContentConversionStepInput {
    constructor() {
        this.id = null;
        this.adId = null;
        this.attributes = '';
        this.attributeName = '';
        this.attributeValue = '';
        this.attributeRemovalStrategy = null;
        this.adjacentInsertionPosition = 'afterend';
        this.doNothingIfAttributeExists = false;
        this.name = '';
        this.selector = '';
        this.fromAttribute = '';
        this.toAttribute = '';
        this.includedHtml = '';
        this.overlayHtml = '';
        this.headHtml = '';
        this.removeTarget = '';
        this.textToFind = '';
        this.textToReplace = '';
        this.linkSelector = '';
        this.linkToContentItem = false;
        this.linkToFirstLink = false;
        this.paused = false;
        this.cssForATag = '';
        this.cssForImgTag = '';
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStepInput.prototype, "id", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStepInput.prototype, "adId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    class_validator_1.IsNotEmpty(),
    class_validator_1.IsIn(index_1.CONVERSION_STEP_TYPES),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "type", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "attributes", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "attributeName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "attributeValue", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsOptional(),
    class_validator_1.IsIn(types_1.CONVERSION_STEP_REMOVE_ATTRIBUTE_STRATEGY_TYPES),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStepInput.prototype, "attributeRemovalStrategy", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsOptional(),
    class_validator_1.IsIn(types_1.CONVERSION_STEP_REMOVE_ATTRIBUTE_STRATEGY_TYPES),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "adjacentInsertionPosition", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], ContentConversionStepInput.prototype, "doNothingIfAttributeExists", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "selector", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "fromAttribute", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "toAttribute", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "includedHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "overlayHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "headHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "removeTarget", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "textToFind", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "textToReplace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "linkSelector", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], ContentConversionStepInput.prototype, "linkToContentItem", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], ContentConversionStepInput.prototype, "linkToFirstLink", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], ContentConversionStepInput.prototype, "paused", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "cssForATag", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], ContentConversionStepInput.prototype, "cssForImgTag", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.Int, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], ContentConversionStepInput.prototype, "imgWidth", void 0);
ContentConversionStepInput = tslib_1.__decorate([
    type_graphql_1.InputType()
], ContentConversionStepInput);
exports.ContentConversionStepInput = ContentConversionStepInput;
//# sourceMappingURL=ContentConversionStepInput.js.map